<template>
  <div
    class="pa-3 ma-3"
  >
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>
    <v-confirm-dialog
      ref="confirm"
      acceptText="Aceptar"
      cancelText="Cancelar"
      @accept="autorizarDicom"
      @cancel="cancelarAutorizacion"
    >
    </v-confirm-dialog>
    <v-dialog
      max-width="65%"
      v-model="dialogAddEdit"
      persistent
    >
      <v-card>
        <v-card-title>
          Editar Mastógrafo
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.no_serie"
                label="Número de Serie"
                outlined
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.id_unidad_medica"
                  :items="unidades_medicas"
                  outlined
                  label="Unidad Medica"
                  :item-text="codigoNombre"
                  item-value="id_unidad_medica"
                  :loading="loadingUnidadesMedicas"
                  dense
                  hide-details
                >
                </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
        <template v-slot:[`item.no_serie`]="{ item }">
            {{item.no_serie || 'N/D'}}
        </template>
         <template v-slot:[`item.autorizado`]="{ item }">
            <v-icon
              v-if="item.autorizado"
              color="green"
            >
              mdi-check-circle
            </v-icon>
            <v-icon
              v-else
              color="yellow"
              @click="openDialogAutorizar(item)"
            >
              mdi-alert
            </v-icon>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogAddEdit(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';
import VConfirmDialog from '@/components/VConfirmDialog.vue';

export default {
  components: {
    VAlertDialog,
    VConfirmDialog
  },
  data: () => ({
    dialogAddEdit: false,
    loading: false,
    items: [],
    headers:[
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
      },
      {
        text: "No. Serie",
        value: "no_serie",
        align: "center",
      },
      {
        text: "Unidad Médica",
        value: "label_unidad_medica",
        align: "center",
      },
      {
        text: "Ultimo Ping",
        value: "ultimo_ping",
        align: "center",
      },
      {
        text: "Autorizado",
        value: "autorizado",
        align: "center",
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%"
      }
    ],
    editedItem: {
      id_dicom_servidor: null,
      id_unidad_medica: null,
      label_unidad_medica: null,
      nombre: null,
      no_serie: null,
      autorizado: null,
      ultimo_ping: null,
    },
    authorizeItem: {
      id_dicom_servidor: null,
      id_unidad_medica: null,
      label_unidad_medica: null,
      nombre: null,
      no_serie: null,
      autorizado: null,
      ultimo_ping: null,
    },
    defaultEditedItem: {
      id_dicom_servidor: null,
      id_unidad_medica: null,
      label_unidad_medica: null,
      nombre: null,
      no_serie: null,
      autorizado: null,
      ultimo_ping: null,
    },
    loadingSave: false,
    loadingUnidadesMedicas: false,
    unidades_medicas: [],
  }),
  mounted() {
    this.getItems();
    this.getUnidadesMedicas();
  },
  methods: {
    codigoNombre: (item) => `[${item.codigo}] - ${item.nombre}`,
    getItems(){
      this.loading = true;
      axios
        .get('/Dicom/Listar')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    openDialogAddEdit(editItem = null){
      if(editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = true;
    },
    closeDialogAddEdit(){
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },
    saveDialogAddEdit(){    
      if (this.editedItem.nombre == null || 
          this.editedItem.nombre.trim().length === 0 || 
          this.editedItem.nombre.length > 256) {

        this.$refs.alert.setMessage("", "Debe de Ingresar un Nombre entre 1 y 256 caracteres");
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.id_unidad_medica == null) {
        this.$refs.alert.setMessage("", "Debe Seleccionar una Unidad Médica");
        this.$refs.alert.open();
        return;
      }

      // 🔹 Normalizamos no_serie
      let noSerie = null;

      if (this.editedItem.no_serie) {
        const trimmed = this.editedItem.no_serie.trim();

        if (trimmed.length === 0) {
          this.$refs.alert.setMessage("", "El número de serie no puede estar vacío.");
          this.$refs.alert.open();
          return;
        }

        noSerie = trimmed;
      }

      this.loadingSave = true;

      axios
      .put(`/Dicom/Editar`, {
        id_dicom_servidor: this.editedItem.id_dicom_servidor,
        nombre: this.editedItem.nombre.trim(),
        no_serie: noSerie, // null o limpio
        id_unidad_medica: this.editedItem.id_unidad_medica
      })
      .then(() => {
        this.getItems();
        this.closeDialogAddEdit();
      })
      .catch(error => {
        if (error.response?.status === 409){
          this.$refs.alert.setMessage("", "Existe un Programa con el mismo Código.");
          this.$refs.alert.open();
          return;
        }

        this.$refs.alert.setMessage("", "Ocurrió un error al guardar.");
        this.$refs.alert.open();
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
    openDialogAutorizar(item){
      this.authorizeItem = item;
      this.$refs.confirm.setMessage('', `¿Desea Autorizar el Mastógrafo con nombre ${item.nombre} ?`);
      this.$refs.confirm.open();
    },
    autorizarDicom(){
      axios
      .put(`Dicom/AutorizarDicom/${this.authorizeItem.id_dicom_servidor}`)
      .then(() => {
        this.getItems();
      })
      .catch(error => {
        console.log(error)
      })
      this.authorizeItem = Object.assign({}, this.defaultEditedItem);
    },
    cancelarAutorizacion(){
      this.authorizeItem = Object.assign({}, this.defaultEditedItem);
    },
    getUnidadesMedicas(){
      this.loadingUnidadesMedicas = true;
      axios
      .get('/Catalogos/ListarUnidadesMedicas?solo_mastografia=true')
      .then(response => {
        this.unidades_medicas = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingUnidadesMedicas = false;
      })
    }
  }
}
</script>